import { render, staticRenderFns } from "./editedBy.vue?vue&type=template&id=fb038372&"
import script from "./editedBy.vue?vue&type=script&lang=js&"
export * from "./editedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports